<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.return_products">
  <app-popup-header
    title="{{isViewMode ? localService.languageContent.return_products.header_returned : localService.languageContent.return_products.header_to_return}}"></app-popup-header>
  <div class="modal-body" *ngIf="source" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div *ngIf="!isViewMode && productsLocal">
      <div *ngIf="productsLocal.length == 0" style="text-align:center;">
        {{localService.languageContent.return_products.no_return}}
      </div>
      <div *ngIf="productsLocal.length > 0">
        <div class="row styled_row">
          <div class="col-12" style="text-align:right;">
            {{localService.languageContent.return_products.total_amt}}
            <span class="en">&nbsp;:&nbsp;</span>
            <span class="en" style="color:red;">{{getTotalAmount() | number: '1.2-2'}}</span>
          </div>
        </div>
        <div class="row styled_row" *ngFor="let item of productsLocal">
          <div class="col-md-5">
            <i class="material-icons delete_icon action_icon" (click)="onRemoveProduct(item.key,item.v15)">cancel</i>
            <span class="en">&nbsp;{{item.v2}}&nbsp;-&nbsp;</span>
            <span [ngClass]="localService.getLanguageCode(item.v6)">{{item.v3}}</span>
            <span *ngIf="item.v15 && item.v15.length > 1" class="en"
              style="font-style:italic">&nbsp;({{item.v16}})</span>
          </div>
          <div class="col-md-7">
            <div class="row">
              <div class="col-8">
                <ngx-select [(ngModel)]="item.v7" [noAutoComplete]="true" [items]="source.returnReasons"
                  [optionValueField]="'key'" [optionTextField]="'value'" (open)="showHideDummyHeight(true)"
                  (close)="showHideDummyHeight(false)">
                </ngx-select>
              </div>
              <div class="col-4" style="text-align:right;">
                <span class="en"
                  title="({{item.v1}} * {{item.v4 | number: '1.2-2'}} / {{getMeasurmentType(item.v5)}})">{{(item.v1 ==
                  null ? 0 : (item.v1 * item.v4)) | number: '1.2-2'}}</span>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="isShowDummyHeight" [ngStyle]="{'height' : localService.getHeightOfOpenedControl(2) + 'px'}">
          &nbsp;
        </div>
      </div>
    </div>
    <div *ngIf="isViewMode">
      <div *ngFor="let item of source.content" class="box" style="margin-bottom:10px;">
        <div class="row styled_row">
          <div class="col-7 en">#{{item.key.key}}&nbsp;&nbsp;{{item.key.v1 | localDate}}</div>
          <div class="col-5" style="text-align:right">
            <span class="button" *ngIf="intractionType != 1" (click)="localService.showSummary(item.key.v2,1)"
              [ngClass]="localService.getLanguageCode(item.key.v3)">{{item.key.v4}}</span>
            <span *ngIf="intractionType == 1"
              [ngClass]="localService.getLanguageCode(item.key.v3)">{{item.key.v4}}</span>
          </div>
        </div>
        <div class="row styled_row" *ngFor="let itemSub of item.values">
          <div class="col-md-5">
            <span class="en">{{itemSub.v2}}&nbsp;-&nbsp;</span>
            <span [ngClass]="localService.getLanguageCode(itemSub.v6)">{{itemSub.v3}}</span>
          </div>
          <div class="col-md-7">
            <div class="row">
              <div class="col-8">
                <span *ngIf="intractionType != 1">{{getReturnReason(itemSub.v7)}}</span>
                <div *ngIf="intractionType == 1">
                  <span class="en">{{itemSub.v1}}&nbsp;*&nbsp;({{itemSub.v4 | number: '1.2-2'}}&nbsp;/&nbsp;</span>
                  <span>{{getMeasurmentType(itemSub.v5)}}</span>
                  <span class="en">)&nbsp;</span>
                </div>
              </div>
              <div class="col-4" style="text-align:right;">
                <span class="en"
                  title="({{itemSub.v1}} * {{itemSub.v4 | number: '1.2-2'}} / {{getMeasurmentType(itemSub.v5)}})">{{(itemSub.v1
                  == null ? 0 : (itemSub.v1 * itemSub.v4)) | number: '1.2-2'}}</span>
                <div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row styled_row">
          <div class="col-12" style="text-align:right;">
            {{localService.languageContent.return_products.total_amt}}
            <span class="en">&nbsp;:&nbsp;</span>
            <span class="en" style="color:red;">{{getTotalAmount(item.values) | number: '1.2-2'}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" *ngIf="!isViewMode" [disabled]="!products || products.length == 0"
      (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>